import util from '@utils/util';
// 引入exploreContent组件，展示内容
import exploreContent from './components/exploreContent';
import globalHeader from '../../../basic/re_header';
import lmClick from '../../../../../mixins/lmClick';

/**
 * 页面list组件
 * 该组件主要负责整合数据，展示列表内容
 */
export default {
  name: 'pageExplore',
  mixins: [lmClick],
  props: {},
  data: function data() {
    return {};
  },
  created: function created() {
    util.handeError();
  },
  components: {
    exploreContent: exploreContent,
    globalHeader: globalHeader
  }
};